/**
 * Formats a stored UUP sample date for an `<input type="date">`.
 *
 * The API saves `start_date`/`end_date` as UTC midnight (e.g. `2026-07-07T00:00:00.000Z`)
 * and delivers the UTC calendar date to the DMP. Converting that timestamp to local time
 * (e.g. with `dayjs(value)`) shows the previous day anywhere west of UTC, so read the
 * calendar date straight from the string instead. Values the user just picked are already
 * `YYYY-MM-DD` and pass through unchanged.
 *
 * @param {string} [value] - An ISO date or timestamp string
 * @returns {string} The date as `YYYY-MM-DD`, or '' when there is no date
 */
export const toDateInputValue = (value) => (value ? String(value).slice(0, 10) : '')
